import { createSlice } from '@reduxjs/toolkit';
import {
  DeleteAccountUser,
  logIn,
  logOut, signUp,
  updateUserAccount,
  updateUserAccountEmail,
  updateUserAccountName,
  UpdateUserPassword
} from './operations';

// Типи додати в інший файл
interface User {
  id: string | null;
  name: string | null;
  email: string | null;
  avatarUser?: string | null;
}

interface AuthState {
  id: User | null;
  user: User | null;
  token: string | null;
  isLoggedIn: boolean;
  isRefreshing: boolean;
  verificationToken: string | null,
  authQRCode: string | null
}

const initialState: AuthState = {
  id: null,
  user: null,
  token: null,
  isLoggedIn: false,
  isRefreshing: false,
  verificationToken: null,
  authQRCode: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: builder => {
  builder
    .addCase(signUp.fulfilled, (state, action) => {
      state.user = {
        id: action.payload.id,
        name: action.payload.name,
        email: action.payload.email,
        avatarUser: action.payload.avatar,
      };
      state.token = action.payload.token;
      state.isLoggedIn = true;
    })
    .addCase(logIn.fulfilled, (state, action) => {
      state.user = {
        id: action.payload.id,
        name: action.payload.name,
        email: action.payload.email,
        avatarUser: action.payload.avatarUser,
      };
      state.token = action.payload.token;
      state.isLoggedIn = true;
    })
    .addCase(logOut.fulfilled, state => {
      state.user = null;
      state.token = null;
      state.isLoggedIn = false;
    })
    .addCase(logOut.rejected, state => {
      state.user = null;
      state.token = null;
      state.isLoggedIn = true;
    })
    .addCase(updateUserAccount.fulfilled, (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isLoggedIn = false;
      state.isRefreshing = false;
    })
    .addCase(updateUserAccount.rejected, (state) => {
      state.user = null;
      state.token = null;
      state.isLoggedIn = false;
      state.isRefreshing = false;
    })
    .addCase(UpdateUserPassword.fulfilled, (state, action) => {
      state.user = action.payload.user
      state.token = action.payload.token;
      state.isLoggedIn = true;
      state.isRefreshing = false;
    })
    .addCase(UpdateUserPassword.pending, (state, action) => {
      state.isRefreshing = false;
      state.isLoggedIn = true;
    })
    .addCase(updateUserAccount.pending, (state) => {
      state.isRefreshing = true;
    })
    .addCase(updateUserAccountName.fulfilled, (state, action) => {
      if (state.user) {
        state.user.name = action.payload.name;
      }
    })
    .addCase(updateUserAccountEmail.fulfilled, (state, action) => {
      if (state.user) {
        state.user.email = action.payload.email;
      }
    })
    .addCase(DeleteAccountUser.fulfilled, state => {
      state.user = null;
      state.token = null;
      state.isLoggedIn = false;
    })
    .addCase(DeleteAccountUser.rejected, state => {
      state.isLoggedIn = false;
    });
  }
});

export const authReducer = authSlice.reducer;